import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProductBanner } from 'src/app/interfaces/product-banner.interface';

@Component({
  selector: 'app-product-banner',
  templateUrl: './product-banner.component.html',
  styleUrls: ['./product-banner.component.scss']
})
export class ProductBannerComponent implements OnInit {
  @Input() detail: ProductBanner;
  constructor(
    private router: Router
  ) { }

  ngOnInit() {
  }

  goTo(detail: ProductBanner){
    this.router.navigateByUrl(`/productos/${detail.id}`)
  }

}
